module.exports = __webpack_public_path__ + "static/img/POST_SCARICA-APP-2.c82ed59.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/marketing/POST_SCARICA-APP-2.png
// module id = Eavs
// module chunks = 1